<h2 mat-dialog-title>Event Balance</h2>
<mat-dialog-content class="event-stats">
  <h4 class="event-stats__counters">
    <span class="event-stats__counter">
      <span class="event-stats__label">Shoutouts sent: </span>
      {{ eventCounter().shoutoutCount || 0 }}
    </span>
    <span class="event-stats__counter">
      <span class="event-stats__label">Kiosk shoutouts sent: </span>
      {{ eventCounter().kioskShoutoutCount || 0 }}
    </span>
    <span class="event-stats__counter">
      <span class="event-stats__label">Gross revenue: </span>
      ${{ eventCounter().grossRevenue.toFixed(2) || "0.00" }}
    </span>
    <span class="event-stats__counter">
      <span class="event-stats__label">Net revenue: </span>
      <span class="event-stats__value--highlight">
        ${{ (eventCounter().netRevenue || 0).toFixed(2) }}
      </span>
    </span>
  </h4>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton [mat-dialog-close]>Close</button>
  <button
    matButton
    [routerLink]="['/', 'user']"
    [mat-dialog-close]
    cdkFocusInitial
  >
    View account
  </button>
</mat-dialog-actions>
